(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 25753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ ToastIcon; }
});

// EXTERNAL MODULE: ./src/styles/stitches/index.ts + 2 modules
var stitches = __webpack_require__(62659);
;// CONCATENATED MODULE: ./src/components/global/ToastIcon/styles.ts

var ToastIconContainer = (0,stitches/* styled */.zo)('img', {
  width: '44px',
  height: '44px'
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/global/ToastIcon/index.tsx


function ToastIcon(_ref) {
  var type = _ref.type;
  var Icon = null;

  switch (type) {
    case 'success':
      Icon = /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIconContainer, {
        src: "/icons/confirm.svg",
        alt: "\xCDcone de confirma\xE7\xE3o"
      });
      break;

    case 'error':
      Icon = /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIconContainer, {
        src: "/icons/error.svg",
        alt: "\xCDcone de confirma\xE7\xE3o"
      });
      break;

    default:
      Icon = /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIconContainer, {
        src: "/icons/confirm.svg",
        alt: "\xCDcone de confirma\xE7\xE3o"
      });
      break;
  }

  return Icon;
}

/***/ }),

/***/ 55437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Login; }
});

// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js + 49 modules
var react_select_esm = __webpack_require__(29846);
// EXTERNAL MODULE: ./src/styles/stitches/index.ts + 2 modules
var stitches = __webpack_require__(62659);
;// CONCATENATED MODULE: ./src/styles/pages/SignIn.tsx


var fadeInSignIn = (0,stitches/* keyframes */.F4)({
  '0%': {
    opacity: 0
  },
  '100%': {
    opacity: 1
  }
});
var slideIn = (0,stitches/* keyframes */.F4)({
  '0%': {
    transform: 'translateX(100%)',
    opacity: 0
  },
  '100%': {
    transform: 'translateX(0%)',
    opacity: 1
  }
});
var Container = (0,stitches/* styled */.zo)('div', {
  position: 'relative',
  width: '100%',
  background: 'linear-gradient(178.86deg, $primary 10.17%, rgba(69, 33, 171, 0.92) 27.44%, rgba(69, 33, 171, 0.88) 43.28%, rgba(69, 33, 171, 0.85421) 61.51%, rgba(69, 33, 171, 0.824252) 78.31%, rgba(69, 33, 171, 0.8) 90.78%, rgba(69, 33, 171, 0.74) 99.02%);',
  display: 'flex',
  minHeight: '100vh'
});
var Wrapper = (0,stitches/* styled */.zo)('div', {
  maxWidth: '90rem',
  width: '100%',
  margin: '0 auto',
  display: 'flex',
  minHeight: '100vh',
  padding: '$5',
  animation: "".concat(fadeInSignIn, " ease-in 0.5s")
});
var NextouContainer = (0,stitches/* styled */.zo)('div', {
  width: '50%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '0.625rem',
  padding: '3.5rem $12',
  position: 'relative',
  background: '$brightColour',
  'img#logo': {
    width: '8.2625rem',
    height: '2.5656rem',
    position: 'absolute',
    top: '3.5rem',
    left: '2.75rem'
  },
  'img#nextou': {
    maxWidth: '34.5625rem',
    height: '34.8125rem',
    width: '100%'
  },
  p: {
    color: '$texts',
    fontSize: '$xl',
    fontWeight: '$medium',
    lineHeight: '30px',
    maxWidth: '28.4375rem',
    width: '100%'
  },
  '@media (max-width: 920px)': {
    display: 'none'
  }
});
var LoginContainer = (0,stitches/* styled */.zo)('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  width: '50%',
  borderTopRightRadius: '0.625rem',
  borderBottomRightRadius: '0.625rem',
  '@media (max-width: 920px)': {
    minHeight: '100vh',
    width: '100%',
    padding: '0px 1rem'
  }
});
var LoginWrapper = (0,stitches/* styled */.zo)("div", {
  maxWidth: '21.4375rem',
  width: '100%',
  margin: '0 auto',
  p: {
    fontWeight: '$regular',
    fontSize: '$md',
    color: '$brightColour',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '8px',
      right: '8px',
      width: '0',
      height: '0',
      borderTop: '5px solid $primary',
      borderRight: '5px solid transparent',
      borderLeft: '5px solid transparent',
      pointerEvents: 'none' // Impede que o elemento pseudo seja clicável

    },
    a: {
      margin: '0'
    }
  },
  a: {
    marginTop: '$5',
    display: 'block',
    color: '$brightColour' // display: 'flex',

  }
});
var LoginSelect = (0,stitches/* styled */.zo)(react_select_esm/* default */.ZP, {
  marginTop: '$9',
  animation: "".concat(slideIn, " 0.3s ease-in")
});
var LoginHeader = (0,stitches/* styled */.zo)('div', {
  display: 'flex',
  gap: '1.4375rem',
  alignItems: 'flex-start',
  h1: {
    fontSize: '3.375rem',
    fontWeight: '$bold',
    lineHeight: '81px',
    color: '$brightColour'
  }
});
var LoginOptions = (0,stitches/* styled */.zo)('ul', {
  listStyle: 'none',
  marginTop: '$9',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '$3',
  li: {
    width: 'inherit',
    height: '3.125rem',
    button: {
      background: 'transparent',
      display: 'flex',
      width: '100%',
      height: '3.125rem',
      alignItems: 'center',
      gap: '$3',
      border: '1px solid $brightColour',
      borderRadius: '$sm',
      transition: 'color 0.2s ease-in',
      '&:hover': {
        strong: {
          color: '$primaryHover'
        }
      },
      div: {
        width: '5.3125rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        background: '$primaryHover',
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px'
      },
      strong: {
        color: '$brightColour'
      }
    }
  }
});
var AboutNextou = (0,stitches/* styled */.zo)('p', {
  marginTop: '$4',
  fontSize: '$md',
  fontFamily: '$default',
  a: {
    fontFamily: 'inherit',
    fontSize: '$md',
    textDecoration: 'none',
    color: '$brightColour',
    transition: 'color 0.2s ease-in',
    span: {
      '&:hover': {
        color: '$primaryHover'
      }
    }
  }
});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/components/pages/Login/styles.ts

var ModalForm = (0,stitches/* styled */.zo)('form', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  height: '100%',
  gap: '$8',
  div: {
    marginBottom: '0px',
    width: '100%',
    strong: {
      color: 'red',
      marginTop: '$2',
      display: 'block'
    }
  },
  'input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill': {
    '-webkit-box-shadow': '0 0 0 1000px rgb(44, 14, 128) inset !important',
    '-webkit-text-fill-color': 'white !important'
  }
});
var ModalFormFooter = (0,stitches/* styled */.zo)('div', {
  display: 'flex',
  gap: '$3',
  width: '100%',
  '@media (max-width: 920px)': {
    flexDirection: 'column'
  },
  button: {
    width: '100%',
    height: '2.625rem',
    borderRadius: '$md',
    border: '2px solid $primaryHover',
    background: '$brightColour',
    fontWeight: '$bold',
    transition: 'color 0.2s ease-in',
    position: 'relative',
    '&:hover': {
      color: '#AEA0E8'
    }
  },
  variants: {
    isLoading: {
      "true": {
        button: {
          cursor: 'not-allowed',
          '&:hover': {
            color: '$texts'
          }
        }
      }
    }
  }
});
var InputGroup = (0,stitches/* styled */.zo)('div', {
  borderBottom: '1px solid $brightColour',
  paddingBottom: '$1',
  display: 'flex',
  alignItems: 'center',
  gap: '$3',
  position: 'relative',
  width: '100%',
  svg: {
    position: 'absolute',
    left: 0,
    zIndex: 99
  },
  input: {
    height: '1.75rem',
    zIndex: 3,
    width: '100%',
    paddingLeft: '$11',
    background: 'transparent',
    border: 0,
    outline: '0',
    color: '$brightColour',
    fontSize: '$md',
    '&:disabled': {
      cursor: 'not-allowed'
    },
    '&::placeholder': {
      color: '$brightColour',
      fontSize: '$md'
    }
  }
});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/yup/index.esm.js
var yup_index_esm = __webpack_require__(16310);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
;// CONCATENATED MODULE: ./node_modules/jwt-decode/build/jwt-decode.esm.js
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ var jwt_decode_esm = (o);
//# sourceMappingURL=jwt-decode.esm.js.map

// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/lib-esm/Auth.js + 133 modules
var Auth = __webpack_require__(96797);
// EXTERNAL MODULE: ./src/components/global/ToastIcon/index.tsx + 1 modules
var ToastIcon = __webpack_require__(25753);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Login/WithEmail/index.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var LoginFormValidation = yup_index_esm/* object */.Ry().shape({
  email: yup_index_esm/* string */.Z_().email().required('Informe seu e-mail'),
  password: yup_index_esm/* string */.Z_().required('Informe sua senha')
});
function ModalWithEmail(_ref) {
  var _errors$email, _errors$password;

  var onClose = _ref.onClose;

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var router = (0,next_router.useRouter)();

  var _useForm = (0,dist_index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(LoginFormValidation)
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  function submit(_x) {
    return _submit.apply(this, arguments);
  }

  function _submit() {
    _submit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var password, email, response, token, group;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              password = _ref2.password, email = _ref2.email;
              _context.prev = 1;
              setIsLoading(true);
              _context.next = 5;
              return Auth/* Auth.signIn */.g.signIn({
                password: password,
                username: email
              });

            case 5:
              response = _context.sent;
              token = jwt_decode_esm(response.signInUserSession.idToken.jwtToken);
              group = token['cognito:groups'][0];

              if (!(group !== 'admin')) {
                _context.next = 10;
                break;
              }

              throw new Error('Just Admin can be access');

            case 10:
              router.push('/escolas');
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              react_toastify_esm/* toast.error */.Am.error( /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "E-Mail ou senha inv\xE1lido"
              }), {
                icon: /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIcon/* ToastIcon */.I, {
                  type: "error"
                })
              });
              setIsLoading(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 13]]);
    }));
    return _submit.apply(this, arguments);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((lib_default()), {
    isOpen: true,
    contentLabel: "Login With Email",
    style: {
      content: {
        background: '#2C0E80',
        border: '1px solid #AEA0E8',
        maxWidth: '450px',
        height: '300px',
        width: '100%'
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalForm, {
      onSubmit: handleSubmit(submit),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputGroup, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdOutlineEmail */.F8X, {
            color: "#fff",
            size: 30
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({
            type: "email"
          }, register('email')), {}, {
            disabled: isLoading,
            placeholder: "Digite seu E-Mail"
          }))]
        }), !!((_errors$email = errors.email) !== null && _errors$email !== void 0 && _errors$email.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: errors.email.message
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputGroup, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiLockPasswordFill */.xuE, {
            size: 30,
            color: "#fff"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread(_objectSpread({
            type: "password"
          }, register('password')), {}, {
            disabled: isLoading,
            placeholder: "Digite sua senha"
          }))]
        }), !!((_errors$password = errors.password) !== null && _errors$password !== void 0 && _errors$password.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: errors.password.message
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalFormFooter, {
        isLoading: isLoading,
        children: [!isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          onClick: onClose,
          children: "Cancelar"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "submit",
          disabled: isLoading,
          children: isLoading ? 'Carregando' : 'Entrar'
        })]
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
;// CONCATENATED MODULE: ./src/components/pages/Login/WithUsername/index.tsx




function WithUsername_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WithUsername_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WithUsername_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WithUsername_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















var WithUsername_LoginFormValidation = yup_index_esm/* object */.Ry().shape({
  username: yup_index_esm/* string */.Z_().required('Informe seu nome de usuário'),
  password: yup_index_esm/* string */.Z_().required('Informe sua senha')
});
function ModalWithUsername(_ref) {
  var _errors$username, _errors$password;

  var onClose = _ref.onClose;

  var _useState = (0,react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var router = (0,next_router.useRouter)();

  var _useForm = (0,dist_index_esm/* useForm */.cI)({
    resolver: (0,yup/* yupResolver */.X)(WithUsername_LoginFormValidation)
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      errors = _useForm.formState.errors;

  function submit(_x) {
    return _submit.apply(this, arguments);
  }

  function _submit() {
    _submit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
      var password, username, response, token, group;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              password = _ref2.password, username = _ref2.username;
              _context.prev = 1;
              setIsLoading(true);
              _context.next = 5;
              return Auth/* Auth.signIn */.g.signIn({
                password: password,
                username: username
              });

            case 5:
              response = _context.sent;
              token = jwt_decode_esm(response.signInUserSession.idToken.jwtToken);
              group = token['cognito:groups'][0];

              if (!(group !== 'admin')) {
                _context.next = 10;
                break;
              }

              throw new Error('Just Admin can be access');

            case 10:
              router.push('/escolas');
              _context.next = 17;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              react_toastify_esm/* toast.error */.Am.error( /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Usu\xE1rio ou senha inv\xE1lido"
              }), {
                icon: /*#__PURE__*/(0,jsx_runtime.jsx)(ToastIcon/* ToastIcon */.I, {
                  type: "error"
                })
              });
              setIsLoading(false);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 13]]);
    }));
    return _submit.apply(this, arguments);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)((lib_default()), {
    isOpen: true,
    contentLabel: "Login With Username",
    style: {
      content: {
        background: '#2C0E80',
        border: '1px solid #AEA0E8',
        maxWidth: '450px',
        height: '300px',
        width: '100%'
      }
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalForm, {
      onSubmit: handleSubmit(submit),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputGroup, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiUser */.fzv, {
            color: "#fff",
            size: 30
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", WithUsername_objectSpread({
            type: "text",
            placeholder: "Nome De Usu\xE1rio"
          }, register('username')))]
        }), !!((_errors$username = errors.username) !== null && _errors$username !== void 0 && _errors$username.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: errors.username.message
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InputGroup, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiLockPasswordFill */.xuE, {
            size: 30,
            color: "#fff"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", WithUsername_objectSpread(WithUsername_objectSpread({
            type: "password"
          }, register('password')), {}, {
            disabled: isLoading,
            placeholder: "Digite sua senha"
          }))]
        }), !!((_errors$password = errors.password) !== null && _errors$password !== void 0 && _errors$password.message) && /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: errors.password.message
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ModalFormFooter, {
        isLoading: isLoading,
        children: [!isLoading && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: onClose,
          type: "button",
          children: "Cancelar"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "submit",
          disabled: isLoading,
          children: isLoading ? 'Carregando' : 'Entrar'
        })]
      })]
    })
  });
}
;// CONCATENATED MODULE: ./src/pages/index.tsx











var __N_SSP = true;
function Login() {
  var _useState = (0,react.useState)(''),
      loginWith = _useState[0],
      setLoginWith = _useState[1];

  function handleOpenModal(type) {
    setLoginWith(type);
  }

  var handleCloseModal = (0,react.useCallback)(function () {
    setLoginWith('');
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [loginWith === 'email' && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalWithEmail, {
      onClose: handleCloseModal
    }), loginWith === 'username' && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalWithUsername, {
      onClose: handleCloseModal
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Nextou - Login"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(NextouContainer, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: "Logo",
          src: "/logo.svg",
          width: 137,
          height: 43.93,
          id: "logo"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 553,
          height: 557,
          src: "/nextouLogin.svg",
          alt: "Nextou",
          id: "nextou"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Fa\xE7a com que o aprendizado fique ao alcance de todos. Comece agora mesmo!"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoginContainer, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LoginWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LoginHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              children: "Login"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/Nestor.svg",
              alt: "Nestor",
              width: 54.94,
              height: 67.73
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(LoginOptions, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                onClick: function onClick() {
                  return handleOpenModal('email');
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdAlternateEmail */.g5G, {
                    size: 20,
                    color: "#fff"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "Entrar com E-Mail"
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
                onClick: function onClick() {
                  return handleOpenModal('username');
                },
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaUser */.Xws, {
                    size: 20,
                    color: "#fff"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: " Entrar com nome Usu\xE1rio"
                })]
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            prefetch: false,
            href: "/esqueci-minha-senha",
            children: "Esqueceu sua senha?"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(AboutNextou, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              passHref: true,
              href: "https://nextou.com.br/",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                target: "_blank",
                children: ["Ainda n\xE3o conhece o Nextou? ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "Saiba Mais"
                })]
              })
            })
          })]
        })
      })]
    })]
  });
}

/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(55437);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56249:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,688,5445,5937,9070,3987,7536,2216,6893,9846,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);